import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import AnimateHeight from 'react-animate-height';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import Step1 from './Step1';
import Step2 from './Step2';
import Step2a from './Step2a';
import Step3 from './Step3';
import SelectModelForm from './SelectModelForm';
import ClientModel from './ClientModel';
import PreferredModels from './PreferredModels';
import {
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import {
  deleteClient,
} from '../../actions/advisor';
import {
} from '../../reducers/advisor';
import s from './EditClient2.css';

library.add(faChevronUp, faChevronDown, faCheckCircle, faClock);

class EditClient2 extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      stepHeights:[1,0,0],
      deleteButton: 'REMOVE CLIENT',
    };
  }

  componentDidMount() {
    const {
    	client,
    } = this.props;
    // open step automatically to next incomplete
    if(client.results.length === 0 && client.laScore === 0) {
      this.setStepToShow(1);
    } else if(!this.getStatusGoals(client)) {
      this.setStepToShow(2);
    } else if(!this.getStatusPortfolio(client)) {
      this.setStepToShow(3);
    }
  }

  deleteClient(client){
    if(this.state.deleteButton === 'REMOVE CLIENT') {
      this.setState(Object.assign({}, this.state, {
        deleteButton: 'CONFIRM REMOVAL',
      }));
    } else {
      this.props.deleteClient(client);
      this.setState(Object.assign({}, this.state, {
        deleteButton: '...',
      }));
    }
  }

  setStepToShowOnSave(step) {
    const {
    	client,
    } = this.props;

    const heights = [0,0,0];

    if(step === 1 && !this.getStatusGoals(client)) {
      heights[1] = 'auto';
    } else if(step === 1 && !this.getStatusPortfolio(client)) {
      heights[2] = 'auto';
    } else if(step === 2 && !this.getStatusPortfolio(client)) {
      heights[2] = 'auto';
    }
    this.setState({ stepHeights:heights });
  }

  setStepToShow(step) {
    const {
      stepHeights,
    } = this.state;

    const heights = [0,0,0];
    if(stepHeights[step - 1] !== 'auto') {
      heights[step - 1] = 'auto';
    }
    this.setState({ stepHeights:heights });
  }

  getStatusTest(client) {
    const completed = [LA_TEST, BS_TEST, RR_TEST, LF_TEST].map((test) => {
      const complete = client.results.filter((result) => result.name === test);
      return complete.length > 0 ? true : false;
    });
    return completed.includes(false) ? false : true;
  }

  getStatusGoals(client) {
    if (client) {
      let hasGoal = false;
      if (client.retireMonthlyIncome && client.retireMonthlyIncome > 0) {
        hasGoal = true;
      }
      if (hasGoal) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  getStatusPortfolio(client) {
    if (client) {
      let hasPort = false;
      if (client.holdings && client.holdings.length > 0) {
        hasPort = true;
      }
      if (hasPort) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  getStatusIcon(isComplete) {
    if (isComplete) {
      return(
        <div>
          <span style={{fontWeight:700}}>Status:</span> complete <FontAwesomeIcon icon="check-circle" size="lg" color="#37BAC0" />
        </div>
      );
    } else {
      return (
        <div>
          <span style={{fontWeight:700}}>Status:</span> incomplete <FontAwesomeIcon icon="clock" size="lg" color="#F44821" />
        </div>
      );
    }
  }

  render() {
    const {
      stepHeights,
      deleteButton,
    } = this.state;

    const {
    	client,
    } = this.props;

    return (
      <div>
        <div className="row">
          <div className={`col-md-9 ${s.clientHeader}`}>
            <div className={s.clientName}>{client.firstName} {client.lastName}</div>
            <div className={s.clientEmail}>{client.email}</div>
          </div>
          <div className={`col-md-3 ${s.clientHeader}`}>
            <div className={s.clientDelete} onClick={() => this.deleteClient(client)}>
              {deleteButton}
            </div>
          </div>
        </div>
        <div className="row" onClick={() => this.setStepToShow(1)}>
          <div className={`col-md-12`}>
            <div className={s.stepBar}>
              <div className={s.stepCaret}><FontAwesomeIcon icon="chevron-down" size="lg" /></div>
              <div className={s.stepText}>Step 1: <span style={{fontWeight:700}}>Complete the Behavioral Finance Assessment with {client.firstName}</span></div>
              <div className={s.stepStatus}>{this.getStatusIcon(this.getStatusTest(client))}</div>
            </div>
          </div>
        </div>
        <AnimateHeight duration={750} height={stepHeights[0]}>
          <div className={s.stepContainer}>
            <Step1 client={client} closeStep={() => this.setStepToShowOnSave(1)}/>
          </div>
        </AnimateHeight>
        <div className="row" onClick={() => this.setStepToShow(2)}>
          <div className={`col-md-12`}>
            <div className={s.stepBar}>
              <div className={s.stepCaret}><FontAwesomeIcon icon="chevron-down" size="lg" /></div>
              <div className={s.stepText}>Step 2: <span style={{fontWeight:700}}>Enter {client.firstName}'s Profile</span></div>
              <div className={s.stepStatus}>{this.getStatusIcon(this.getStatusGoals(client))}</div>
            </div>
          </div>
        </div>
        <AnimateHeight duration={750} height={stepHeights[1]}>
          <div className={s.stepContainer}>
            <Step2a client={client} />
            <Step2 client={client} closeStep={() => this.setStepToShowOnSave(2)} />
          </div>
        </AnimateHeight>
        <div className="row" onClick={() => this.setStepToShow(3)}>
          <div className={`col-md-12`}>
            <div className={s.stepBar}>
              <div className={s.stepCaret}><FontAwesomeIcon icon="chevron-down" size="lg" /></div>
              <div className={s.stepText}>Step 3: <span style={{fontWeight:700}}>Enter {client.firstName}’s Current Portfolio & Adjust the Portfolio Blend</span></div>
              <div className={s.stepStatus}>{this.getStatusIcon(this.getStatusPortfolio(client))}</div>
            </div>
          </div>
        </div>
        <AnimateHeight duration={750} height={stepHeights[2]}>
          <div className={s.stepContainer}>
            <Step3 client={client} closeStep={() => this.setStepToShowOnSave(3)}/>
          </div>
        </AnimateHeight>
        {(client.isDirty || client.fullTermModels.length === 0) &&
          <div className="row" style={{marginTop:'28px'}}>
            {/* <div className="col-md-3" /> */}
            <div className="col-md-12">
              <SelectModelForm client={client} />
            </div>
          </div>
        }
        {(!client.isDirty && client.fullTermModels.length > 0) &&
          <React.Fragment>
            <ClientModel client={client} />
            <PreferredModels client={client} />
          </React.Fragment>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {
  deleteClient,
})(EditClient2);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditClient2.js